/**
 * Javascript file for the page to list the exemplary business models.
 * @author Adrian Rebmann, Andrea Villeda
 */

export default {
  name: "BMExample",

  /**
   * The vue instance's data object.
   */
  data() {
    return {};
  },

  /**
   * Called after the instance has been created.
   */
  created() {},
  
  /**
   * The vue instance's method declaration.
   */
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/company/businessmodel/example/bmexample.js